
/**
 * Export `sortedSocialNetworks`.
 */

export const sortedSocialNetworks = [
  'twitter',
  'airchat',
  'facebook',
  'instagram',
  'linkedin',
  'tiktok',
  'slack',
  'telegram',
  'discord',
  'medium',
  'substack'
];
